export enum SituacaoTopicoEnum {

  fechado = "Fechado",
  indeferido = "Indeferido",
  aberto = "Aberto"
}
